import ButtonSettingsNew from 'client/components/core/Sidebar/components/Settings/entities/button-settings'
import CheckboxSettings from 'client/components/core/Sidebar/components/Settings/entities/CheckboxSettings'
import CountdownSettings from 'client/components/core/Sidebar/components/Settings/entities/Countdown'
import RowSettings from 'client/components/core/Sidebar/components/Settings/entities/RowSettings'
import SectionSettings from 'client/components/core/Sidebar/components/Settings/entities/SectionSettings'
import ShippingFeesSettings from 'client/components/core/Sidebar/components/Settings/entities/ShippingFeesSettings'
import CustomerTypeSettingsNew from 'client/pages/offer/settings/CustomerTypeSettings'
import PaymentButtonSettingsNew from 'client/pages/offer/settings/PaymentButtonSettingsNew'
import ProductSettings from 'client/pages/offer/settings/ProductSettings'
import { RowInterface } from 'common/components/entities/Row/types/RowInterface'
import { SectionInterface } from 'common/components/entities/Section/types/SectionInterface'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { AudioInterface } from 'common/types/entities/AudioInterface'
import { BlogPostImageInterface } from 'common/types/entities/BlogPostImageInterface'
import { BookingCalendarInterface } from 'common/types/entities/BookingCalendarInterface'
import { BulletListInterface } from 'common/types/entities/BulletListInterface'
import { BookingPaidCalendarInterface } from 'common/types/entities/booking-paid-calendar-interface'
import { ContentBoxInterface } from 'common/types/entities/ContentBoxInterface'
import { ContentTableInterface } from 'common/types/entities/ContentTableInterface'
import { CountdownInterface } from 'common/types/entities/CountdownInterface'
import { CustomerTypeInterface } from 'common/types/entities/CustomerTypeInteface'
import { CustomLoginForgotPasswordInterface } from 'common/types/entities/CustomLoginForgotPasswordInterface'
import CustomLoginInterface from 'common/types/entities/CustomLoginInterface'
import EntityInterface, {
  BaseEntityInterface,
} from 'common/types/entities/EntityInterface'
import { FieldInterface } from 'common/types/entities/field-interface'
import { HeadlineInterface } from 'common/types/entities/HeadlineInterface'
import { HorizontalLineInterface } from 'common/types/entities/HorizontalLineInterface'
import { ImageInterface } from 'common/types/entities/ImageInterface'
import { LanguageSwitcherInterface } from 'common/types/entities/LanguageSwitcherInterface'
import ProductEntityInterface from 'common/types/entities/ProductInterface'
import { PopupInterface } from 'common/types/entities/popup-interface'
import { PriceElementInterface } from 'common/types/entities/price-element-interface'
import { RawHtmlInterface } from 'common/types/entities/RawHtmlInterface'
import { RecaptchaInterface } from 'common/types/entities/RecaptchaInterface'
import { ShippingFeesInterface } from 'common/types/entities/ShippingFeesInterface'
import { SurveyInterface } from 'common/types/entities/SurveyInterface'
import { SearchResultsInterface } from 'common/types/entities/search-results-interface'
import { TextAreaInterface } from 'common/types/entities/TextAreaInterface'
import { TextInterface } from 'common/types/entities/TextInterface'
import { TwitterTweetButtonInterface } from 'common/types/entities/TwitterTweetButtonInterface'
import { VideoInterface } from 'common/types/entities/VideoInterface'
import React from 'react'
import { FormSettings } from 'src/editor/shared/entities/form/form-settings'
import { LoginButtonSettings } from 'src/editor/shared/entities/login-button/login-button-settings'
import { RegistrationButtonSettings } from 'src/editor/shared/entities/registration-button/registration-button-settings'
import { SearchSettings } from 'src/editor/shared/entities/search/search-settings'
import { WebsiteButtonSettings } from 'src/editor/shared/entities/website-button/website-button-settings'
import { WebsiteHeaderSettings } from 'src/editor/shared/entities/website-header/website-header-settings'
import { WebsiteLanguageSwitcherSettings } from 'src/editor/shared/entities/website-language-switcher/settings/website-language-switcher-settings'
import { WebsiteLogoSettings } from 'src/editor/shared/entities/website-logo/website-logo-settings'
import { MenuSettings } from 'src/editor/shared/settings/menu-settings'
import { WebsiteFooterSettings } from 'src/editor/shared/settings/website-footer-settings'
import { WebsiteLoginSettings } from 'src/editor/shared/settings/website-login-settings'
import { WebsitePageBodySettings } from 'src/editor/shared/settings/website-page-body-settings'
import { AgreementInterface } from 'src/shared/entities/agreement/agreement.schema'
import { ActionButtonEntityInterface } from 'src/shared/entities/button/action-button.schema'
import { CarouselInterface } from 'src/shared/entities/carousel/carousel.schema'
import { CheckboxEntityInterface } from 'src/shared/entities/checkbox/checkbox-entity.schema'
import { CouponInterface } from 'src/shared/entities/coupon/coupon.schema'
import { FaqInterface } from 'src/shared/entities/faq/faq.schema'
import { LoginButtonEntityInterface } from 'src/shared/entities/login-button/login-button-entity.schema'
import { PaymentButtonEntityInterface } from 'src/shared/entities/payment-button/payment-button.schema'
import { RegistrationButtonEntityInterface } from 'src/shared/entities/registration-button/registration-button-entity.schema'
import { WebsiteButtonEntityInterface } from 'src/shared/entities/website-button/website-button.schema'
import { BaseEntityNewInterface } from 'src/shared/schemas/base-entity.schema'
import { EntityInnerItemInterface } from 'src/shared/schemas/entity-inner-item.schema'
import { FormInterface } from 'src/shared/types/entities/form-interface'
import { MenuInterface } from 'src/shared/types/entities/menu'
import { SearchInterface } from 'src/shared/types/entities/search-interface'
import { WebsiteLanguageSwitcherInterface } from 'src/shared/types/entities/website-language-switcher-interface'
import { WebsiteLoginInterface } from 'src/shared/types/entities/website-login-interface'
import { WebsiteLogoInterface } from 'src/shared/types/entities/website-logo-interface'
import { EntityNewInterfacesType } from 'src/shared/types/entity-new-interfaces-type'
import {
  WebsiteFooterInterface,
  WebsiteHeaderInterface,
  WebsitePageInterface,
} from 'src/shared/types/website-entities'
import AudioSettingsNew from './AudioSettingsNew'
import BlogPostImageSettings from './BlogPostImageSettings'
import BookingCalendarSettings from './BookingCalendarSettings'
import { BookingPaidCalendarSettings } from './booking-paid-calendar-settings'
import CarouselSettings from './CarouselSettings'
import ContentBoxSettings from './ContentBoxSettings'
import ContentTableSettings from './ContentTableSettings'
import CustomLoginSettings from './CustomLogin'
import ForgotPasswordSettings from './CustomLogin/components/ForgotPasswordSettings'
import CouponSettings from './coupon-settings'
import FaqSettings from './FaqSettings'
import FaqItemSettings from './FawItemSettings'
import FieldSettings from './field-settings'
import HeadlineSettings from './HeadlineSettings'
import ImageSettingsNew from './ImageSettingsNew'
import NewAgreementSettings from './NewAgreementSettings/NewAgreementSettings'
import NewBulletListSettings from './NewBulletListSettings'
import NewHorizontalLineSettings from './NewHorizontalLineSettings'
import NewLanguageSwitcherSettings from './NewLanguageSwitcherSettings'
import NewRawHtmlSettings from './NewRawHtmlSettings'
import OfferThankYouOrderSummarySettingsNew from './OfferThankYouOrderSummarySettingsNew'
import { PopupSettingsNew } from './popup-settings'
import { PriceElementSettings } from './price-element-settings'
import RecaptchaSettings from './RecaptchaSettings'
import SurveySettings from './SurveySettings/SurveySettings'
import { SearchResultsSettings } from './search-results-settings'
import TextAreaSettings from './TextAreaSettings'
import TextSettingsNew from './TextSettingsNew'
import TwitterTweetButtonSettings from './TwitterTweetButtonSettings'
import VideoSettingsNew from './VideoSettingsNew'

export type SettingsProps<T> = {
  entity: T
  defaultEntity?: T
}

export default function createEntitySettings(
  entity:
    | EntityInterface
    | EntityInnerItemInterface
    | BaseEntityNewInterface
    | EntityNewInterfacesType,
  defaultEntity?:
    | EntityInterface
    | EntityInnerItemInterface
    | BaseEntityInterface
    | EntityNewInterfacesType,
) {
  switch (entity.type) {
    case EntityTypeEnum.Image:
      return (
        <ImageSettingsNew
          entity={entity as ImageInterface}
          defaultEntity={defaultEntity as ImageInterface}
        />
      )
    case EntityTypeEnum.LanguageSwitcher:
      return (
        <NewLanguageSwitcherSettings
          entity={entity as LanguageSwitcherInterface}
          defaultEntity={defaultEntity as LanguageSwitcherInterface}
        />
      )
    case EntityTypeEnum.Checkbox:
      return (
        <CheckboxSettings
          entity={entity as CheckboxEntityInterface}
          defaultEntity={defaultEntity as CheckboxEntityInterface}
        />
      )
    case EntityTypeEnum.Text:
      return (
        <TextSettingsNew
          entity={entity as TextInterface}
          defaultEntity={defaultEntity as TextInterface}
        />
      )
    case EntityTypeEnum.RawHtml:
      return (
        <NewRawHtmlSettings
          entity={entity as RawHtmlInterface}
          defaultEntity={defaultEntity as RawHtmlInterface}
        />
      )
    case EntityTypeEnum.Headline:
      return (
        <HeadlineSettings
          entity={entity as HeadlineInterface}
          defaultEntity={defaultEntity as HeadlineInterface}
        />
      )
    case EntityTypeEnum.Carousel:
      return (
        <CarouselSettings
          entity={entity as CarouselInterface}
          defaultEntity={defaultEntity as CarouselInterface}
        />
      )
    case EntityTypeEnum.Faq:
      return (
        <FaqSettings
          entity={entity as FaqInterface}
          defaultEntity={defaultEntity as FaqInterface}
        />
      )
    case EntityTypeEnum.FaqItem:
      return (
        <FaqItemSettings
          entity={entity as FaqInterface}
          defaultEntity={defaultEntity as FaqInterface}
        />
      )
    case EntityTypeEnum.PriceElement:
      return (
        <PriceElementSettings
          entity={entity as PriceElementInterface}
          defaultEntity={defaultEntity as PriceElementInterface}
        />
      )
    case EntityTypeEnum.SearchResults:
      return (
        <SearchResultsSettings
          entity={entity as SearchResultsInterface}
          defaultEntity={defaultEntity as SearchResultsInterface}
        />
      )
    case EntityTypeEnum.Search:
      return <SearchSettings entity={entity as SearchInterface} />
    case EntityTypeEnum.CustomLogin:
      return (
        <CustomLoginSettings
          entity={entity as CustomLoginInterface}
          defaultEntity={defaultEntity as CustomLoginInterface}
        />
      )
    case EntityTypeEnum.BlogPostImage:
      return <BlogPostImageSettings entity={entity as BlogPostImageInterface} />
    case EntityTypeEnum.ContentTable:
      return (
        <ContentTableSettings
          entity={entity as ContentTableInterface}
          defaultEntity={defaultEntity as ContentTableInterface}
        />
      )
    case EntityTypeEnum.TextArea:
      return (
        <TextAreaSettings
          entity={entity as TextAreaInterface}
          defaultEntity={defaultEntity as TextAreaInterface}
        />
      )
    case EntityTypeEnum.TwitterTweetButton:
      return (
        <TwitterTweetButtonSettings
          entity={entity as TwitterTweetButtonInterface}
          defaultEntity={defaultEntity as TwitterTweetButtonInterface}
        />
      )
    case EntityTypeEnum.OrderSummary:
      return (
        <OfferThankYouOrderSummarySettingsNew
          entity={entity as EntityInterface}
          defaultEntity={defaultEntity as EntityInterface}
        />
      )
    case EntityTypeEnum.Menu:
      return (
        <MenuSettings
          entity={entity as MenuInterface}
          defaultEntity={defaultEntity as MenuInterface}
        />
      )
    case EntityTypeEnum.WebsiteLogo:
      return <WebsiteLogoSettings entity={entity as WebsiteLogoInterface} />
    case EntityTypeEnum.Survey:
      return (
        <SurveySettings
          entity={entity as SurveyInterface}
          defaultEntity={defaultEntity as SurveyInterface}
        />
      )
    case EntityTypeEnum.Video:
      return (
        <VideoSettingsNew
          entity={entity as VideoInterface}
          defaultEntity={defaultEntity as VideoInterface}
        />
      )
    case EntityTypeEnum.HorizontalLine:
      return (
        <NewHorizontalLineSettings
          entity={entity as HorizontalLineInterface}
          defaultEntity={defaultEntity as HorizontalLineInterface}
        />
      )
    case EntityTypeEnum.Form:
      return (
        <FormSettings
          entity={entity as FormInterface}
          defaultEntity={defaultEntity as FormInterface}
        />
      )
    case EntityTypeEnum.Field:
      return (
        <FieldSettings
          entity={entity as FieldInterface}
          defaultEntity={defaultEntity as FieldInterface}
        />
      )
    case EntityTypeEnum.Audio:
      return (
        <AudioSettingsNew
          entity={entity as AudioInterface}
          defaultEntity={defaultEntity as AudioInterface}
        />
      )
    case EntityTypeEnum.Product:
      return <ProductSettings entity={entity as ProductEntityInterface} />
    case EntityTypeEnum.Countdown:
      return (
        <CountdownSettings
          entity={entity as CountdownInterface}
          defaultEntity={defaultEntity as CountdownInterface}
        />
      )
    case EntityTypeEnum.Coupon:
      return (
        <CouponSettings
          entity={entity as CouponInterface}
          defaultEntity={defaultEntity as CouponInterface}
        />
      )
    case EntityTypeEnum.Recaptcha:
    case EntityTypeEnum.OptInRecaptcha:
    case EntityTypeEnum.ContactUsRecaptcha:
      return (
        <RecaptchaSettings
          entity={entity as RecaptchaInterface}
          defaultEntity={defaultEntity as RecaptchaInterface}
        />
      )
    case EntityTypeEnum.CustomLoginForgotPassword:
      return (
        <ForgotPasswordSettings
          entity={entity as CustomLoginForgotPasswordInterface}
          defaultEntity={defaultEntity as CustomLoginForgotPasswordInterface}
        />
      )
    case EntityTypeEnum.CustomerType:
      return (
        <CustomerTypeSettingsNew
          entity={entity as CustomerTypeInterface}
          defaultEntity={defaultEntity as CustomerTypeInterface}
        />
      )
    case EntityTypeEnum.ContentBox:
      return (
        <ContentBoxSettings
          entity={entity as ContentBoxInterface}
          defaultEntity={defaultEntity as ContentBoxInterface}
        />
      )
    case EntityTypeEnum.Row:
      return (
        <RowSettings
          entity={entity as RowInterface}
          defaultEntity={defaultEntity as RowInterface}
        />
      )
    case EntityTypeEnum.Section:
      return (
        <SectionSettings
          entity={entity as SectionInterface}
          defaultEntity={defaultEntity as SectionInterface}
        />
      )
    case EntityTypeEnum.ShippingFees:
      return (
        <ShippingFeesSettings
          entity={entity as ShippingFeesInterface}
          defaultEntity={defaultEntity as ShippingFeesInterface}
        />
      )
    case EntityTypeEnum.BulletList:
      return (
        <NewBulletListSettings
          entity={entity as BulletListInterface}
          defaultEntity={defaultEntity as BulletListInterface}
        />
      )
    case EntityTypeEnum.BookingCalendar:
      return (
        <BookingCalendarSettings
          entity={entity as BookingCalendarInterface}
          defaultEntity={defaultEntity as BookingCalendarInterface}
        />
      )
    case EntityTypeEnum.BookingPaidCalendar:
      return (
        <BookingPaidCalendarSettings
          entity={entity as BookingPaidCalendarInterface}
          defaultEntity={defaultEntity as BookingPaidCalendarInterface}
        />
      )
    case EntityTypeEnum.PaymentButton:
      return (
        <PaymentButtonSettingsNew
          entity={entity as PaymentButtonEntityInterface}
          defaultEntity={defaultEntity as PaymentButtonEntityInterface}
        />
      )
    case EntityTypeEnum.Agreement:
      return (
        <NewAgreementSettings
          entity={entity as AgreementInterface}
          defaultEntity={defaultEntity as AgreementInterface}
        />
      )
    case EntityTypeEnum.Button:
      return (
        <ButtonSettingsNew
          entity={entity as ActionButtonEntityInterface}
          defaultEntity={defaultEntity as ActionButtonEntityInterface}
        />
      )
    case EntityTypeEnum.WebsiteButton:
      return (
        <WebsiteButtonSettings
          entity={entity as WebsiteButtonEntityInterface}
          defaultEntity={defaultEntity as WebsiteButtonEntityInterface}
        />
      )
    case EntityTypeEnum.LoginButton:
      return (
        <LoginButtonSettings
          entity={entity as LoginButtonEntityInterface}
          defaultEntity={defaultEntity as LoginButtonEntityInterface}
        />
      )
    case EntityTypeEnum.RegistrationButton:
      return (
        <RegistrationButtonSettings
          entity={entity as RegistrationButtonEntityInterface}
          defaultEntity={defaultEntity as RegistrationButtonEntityInterface}
        />
      )
    case EntityTypeEnum.Popup:
      // NOTE: workaround for typescript issue, need to fix it
      return (
        <PopupSettingsNew
          entity={entity as unknown as PopupInterface}
          defaultEntity={defaultEntity as PopupInterface}
        />
      )
    case EntityTypeEnum.WebsiteLayoutBody:
    case EntityTypeEnum.WebsitePageBody:
      return <WebsitePageBodySettings entity={entity as WebsitePageInterface} />
    case EntityTypeEnum.WebsiteFooter:
      return <WebsiteFooterSettings entity={entity as WebsiteFooterInterface} />
    case EntityTypeEnum.WebsiteHeader:
      return (
        <WebsiteHeaderSettings
          entity={entity as WebsiteHeaderInterface}
          defaultEntity={defaultEntity as WebsiteHeaderInterface}
        />
      )
    case EntityTypeEnum.WebsiteLogin:
      return (
        <WebsiteLoginSettings
          entity={entity as WebsiteLoginInterface}
          defaultEntity={defaultEntity as WebsiteLoginInterface}
        />
      )
    case EntityTypeEnum.WebsiteLanguageSwitcher:
      return (
        <WebsiteLanguageSwitcherSettings
          entity={entity as WebsiteLanguageSwitcherInterface}
          defaultEntity={defaultEntity as WebsiteLanguageSwitcherInterface}
        />
      )
    default:
      return <div />
  }
}
